import React from "react";
import { PaymentVerifyWidgetStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import {
  //  Buttons,
  Displays,
  Forms,
  Icons,
} from "components";
import axios from "axios";
import moment from "moment";

class PaymentVerifyWidget extends React.Component {
  state = {
    isLoading: true,
    step: 1,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    this.setState({
      isLoading: false,
    });

    // const { authenRedux } = this.props;
    // let res = await userService.GET_SCHOOL_BY_CODE(authenRedux.school_code);
    // if (res && res.status === 200) {
    //   this.setState({
    //     isLoading: false,
    //     data: res.data,
    //   });
    // }
  };

  handleDownloadQrCode = async (imageUrl) => {
    try {
      // ตรวจสอบว่ามี URL หรือไม่
      if (!imageUrl) {
        toast.error(this.props.t("QR Code image not found", { ns: "common" }));
        return;
      }

      // สร้าง canvas เพื่อแปลงรูป
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      // ป้องกัน CORS error
      img.crossOrigin = "anonymous";

      img.onload = () => {
        // ตั้งค่าขนาด canvas
        canvas.width = img.width;
        canvas.height = img.height;

        // วาดรูปลง canvas
        ctx.drawImage(img, 0, 0);

        // แปลงเป็น blob
        canvas.toBlob((blob) => {
          if (blob) {
            // สร้าง download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `yamaha-qr-payment-${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            toast.success(this.props.t("QR Code downloaded successfully", { ns: "common" }));
          } else {
            toast.error(this.props.t("Download failed", { ns: "common" }));
          }
        }, "image/png");
      };

      img.onerror = () => {
        toast.error(this.props.t("Cannot load QR Code image", { ns: "common" }));
      };

      // โหลดรูป
      img.src = imageUrl;
    } catch (error) {
      console.error("Download QR Code error:", error);
      toast.error(this.props.t("Download error", { ns: "common" }));
    }
  };

  // API ตอบ error เป็น { error: { message } } (truthy) ต้องแปลงเป็นข้อความให้ลูกค้าเอง
  renderUploadError = (res) => {
    const { t } = this.props;
    const message = res?.data?.error?.message || "";
    if (message.includes("Slip already uploaded")) {
      return t("This slip has already been uploaded", { ns: "common" });
    }
    if (message.includes("please refresh")) {
      return t("Booking was updated, please refresh and try again", {
        ns: "common",
      });
    }
    return t("Upload failed", { ns: "common" });
  };

  handleSubmit = async (values) => {
    const { room_booking_id, onSuccess } = this.props;
    this.setState({
      isBgLoading: true,
    });
    const bodyFormData = new FormData();
    bodyFormData.append("file", values?.slip_file[0]);
    let res;
    try {
      res = await axios.post(
        "https://connect.slip2go.com/api/verify-slip/qr-image/info",
        bodyFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${process.env.REACT_APP_SLIP_SECRET_KEY}`,
          },
        }
      );
    } catch (error) {
      // slip2go ตอบ error (เช่น อ่าน QR ไม่ได้) axios จะ throw ถือเป็นสลิปไม่ถูกต้อง
      res = null;
    }
    if (res && res.data.code === "200000") {
      const resSlip = res.data.data;
      console.log("resSlip", resSlip);
      const bodyFormData = new FormData();
      bodyFormData.append("image", values?.slip_file[0]);
      // bodyFormData.append("bank_branch_name", "เดอะมอลล์ ท่าพระ");
      let resTransaction = await userService.POST_UPLOAD_MUSIC_HALL_SLIP(
        bodyFormData
      );
      if (resTransaction && resTransaction.status === 200) {
        let params = {
          bank_service: resSlip.receiver.bank?.name,
          bank_account_number: resSlip.receiver?.account?.proxy?.account,
          bank_account_name: resSlip.receiver?.account?.name,
          slip_upload: resTransaction.data.path,
          reference_id: resSlip.referenceId,
          trans_ref: resSlip.transRef,
          transfer_amount: resSlip.amount,
          paid_at: resSlip.dateTime,
        };
        let resBookingSlip = await userService.PATCH_ROOM_BOOKING_SLIP_UPDATE(
          room_booking_id,
          params
        );
        if (resBookingSlip && resBookingSlip.status === 200) {
          this.setState({
            paymentData: { amount: resSlip.amount, date: resSlip.dateTime },
            step: 4,
            isBgLoading: false,
          });
          toast.success(this.props.t("Upload success", { ns: "common" }));
          onSuccess && onSuccess();
        } else {
          this.setState({
            isBgLoading: false,
          });
          toast.error(this.renderUploadError(resBookingSlip));
        }
      } else {
        this.setState({
          isBgLoading: false,
        });
        toast.error(this.props.t("Upload failed", { ns: "common" }));
      }
    } else {
      this.setState({
        step: 3,
        isBgLoading: false,
      });
      toast.error(this.props.t("Invalid transfer slip. Please check again.", { ns: "common" }));
    }
  };

  render() {
    const { t } = this.props;
    const { isBgLoading, isLoading, paymentData, step } = this.state;
    return (
      <PaymentVerifyWidgetStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <>
            <div className="payment_header_layout">
              <div className="payment_title">
                {t("Payment Detail", { ns: "room" })}
              </div>
              <div className="account_detail">
                <div className="row_left">
                  {t("Account Number", { ns: "room" })}
                </div>
                <div className="row_right">
                  <div className="desc">008-6-08860-2</div>
                  <div className="desc">
                    {"บริษัท สยามดนตรียามาฮ่า\nSIAM MUSIC YAMAHA"}
                  </div>
                  <div className="desc">{t("Krungthai Bank", { ns: "common" })}</div>
                </div>
              </div>
              <div className="qr_block">
                <img
                  className="qrcode_img"
                  // src={IMG_PATH + data.qr_code}
                  src="/assets/images/icons/qrcode.jpg"
                  alt="qr_payment"
                />
              </div>
              <div
                className="btn_download"
                onClick={() =>
                  // this.handleDownloadQrCode(IMG_PATH + data.qr_code)
                  this.handleDownloadQrCode("/assets/images/mockups/qrcode.png")
                }
              >
                <Icons.Download />
                {t("Download QR Code", { ns: "common" })}
              </div>
            </div>
            {step === 1 && (
              <div className="sec">
                <Forms.UploadSlipForm onSubmit={this.handleSubmit} />
              </div>
            )}
            {step === 2 && (
              <>
                <div className="pay_err_wrap">
                  <Icons.PendingCircle />
                  <div className="err_desc">
                    <div className="err_title">
                      {t("Transfer slip pending verification", { ns: "common" })}
                    </div>

                    {/* <div className="err_title ">
                    Transfer Slip incorrect, Please recheck.{" "}
                  </div> */}
                  </div>
                </div>
                {/* <div className="btn_back_wrap">
                  <Buttons.BgStandard
                    label={"ย้อนกลับ"}
                    onClick={() => {
                      this.setState({ step: 1 });
                    }}
                  />
                </div> */}
              </>
            )}
            {step === 3 && (
              <>
                <div className="pay_err_wrap">
                  <Icons.UnSuccessIcon />
                  <div className="err_desc">
                    <div className="err_title">
                      {t("Invalid transfer slip. Please check again.", { ns: "common" })}
                    </div>
                    <div className="err_title ">
                      Transfer Slip incorrect, Please recheck.{" "}
                    </div>
                  </div>
                </div>
                {/* ให้อัปใหม่ได้ทันที ไม่ต้องปิดแล้วเปิดใหม่ */}
                <div className="sec">
                  <Forms.UploadSlipForm onSubmit={this.handleSubmit} />
                </div>
              </>
            )}
            {step === 4 && (
              <div className="success_wrap">
                <Icons.SuccessIcon />
                <div className="success_desc">
                  <div className="date">
                    {moment(paymentData.date).format("DD/MM/YYYY")}
                  </div>
                  <div className="success_title">
                    โอนเงินสำเร็จ / Transfered
                  </div>
                  <div className="success_desc">
                    กรุณารอแอดมินตรวจสอบ เพื่อดำเนินการออกใบเสร็จ
                  </div>
                  <div className="success_desc">
                    Please await admin to check for issue a receipt
                  </div>
                </div>
                <div className="amount">
                  {paymentData.amount} <span>บาท</span>
                </div>
              </div>
            )}
          </>
        )}
      </PaymentVerifyWidgetStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["room", "common"])(withRouter(PaymentVerifyWidget)));
